module.exports = __webpack_public_path__ + "img/دورو.fde015de.png";